import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { colorScheme } from 'src/app/shared/constants/static-variable';
import { PricePipe } from 'src/app/shared/pipe/price.pipe';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
@Component({
  selector: 'app-company-funding',
  templateUrl: './company-funding.component.html',
  styleUrls: ['./company-funding.component.scss'],
})
export class CompanyFundingComponent implements OnInit {
  @Output() itemAddedToCart: EventEmitter<any> = new EventEmitter();

  @Input() cin: any;
  @Input() all_data: any;
  funding_list: any[] = [];
  years: string[] = [];
  tempYear;
  assesmentYear: UntypedFormGroup;

  // single: any[];
  fundingYearlyData: any = {};
  fundingChartData: any[] = [];
  multi: any[];

  view: any[] = [700, 200];
  colorScheme3 = {
    domain: [
      '#0066FF',
      '#111111',
      '#1F78B4',
      '#0C87F9',
      '#1a1aff',
      '#1aa3ff',
      ' #3366ff',
      ' #4db8ff',
      '#0000e6',
      '#4da6ff',
    ],
  };
  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Country';
  showYAxisLabel = true;
  yAxisLabel = 'Population';
  showLabels = true;

  colorScheme1 = colorScheme;
  colorScheme2 = colorScheme;

  colorScheme = {
    domain: [],
  };

  shareHolderList: any[] = [];
  shareHolderList1: any[] = [];
  shareHolderList2: any[] = [];
  fragment: any;

  haveCumulativeFunding = false;
  haveCumulativeFundingYear = '';
  productList: any;
  onSession: any;

  constructor(
    private localStorageService: LocalStorageService,
    private router: ActivatedRoute,
    private route: Router,
    private commonService: CommonService,
    private tansactionService: TansactionService,
    private toastService: ToastService,
    private loginSignupService: LoginSignupService
  ) {}

  isPremium = false;
  plan: any;
  isAdvance = false;
  isFree = false;

  shareHolderData: any[] = [];

  ngOnInit(): void {
    this.onSession = this.localStorageService.getItem('onSession');
    this.router.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });
    this.assesmentYear = new UntypedFormGroup({
      ay: new UntypedFormControl('', Validators.required),
    });
    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }

    if(this.all_data.cin == 'L72200DL2000PLC108985' || this.all_data.cin == 'L93030DL2010PLC198141'){
      this.isPremium = true;
      this.isAdvance = false;
      this.isFree = false;
      this.plan = 'plan_premium';
    }

    this.funding_list = this.all_data.funding_list;
    this.productList = this.all_data.product_list;
    this.commonService.putProductData(this.all_data.product_list['FDS']);
    this.getFundingGraphData();
    let shareHolderList = Object.create(this.all_data.share_holders);
    if (shareHolderList.length > 0) {
      if (shareHolderList[0].blurred == undefined) {
        shareHolderList.forEach((data: any) => {
          let foundUpdate = false;
          let shareHolderResult = {
            name: data?.name,
            value: data?.percent_of_share.replace('%', ''),
          };
          if (!foundUpdate) {
            this.shareHolderData.push(shareHolderResult);
            this.colorScheme.domain.push(
              '#' +
                [...'000000'].map(() => Math.random().toString(16)[2]).join('')
            );
          }
        });
        let tempShareHolderList = Object.create(shareHolderList);
        if (tempShareHolderList.length > 6) {
          const middleIndex = Math.ceil(tempShareHolderList.length / 2);
          this.shareHolderList1 = tempShareHolderList.splice(0, middleIndex);
          this.shareHolderList2 = tempShareHolderList;
        } else {
          this.shareHolderList1 = this.all_data.share_holders;
        }
      }
    }
  }

  ngAfterViewChecked(): void {
    try {
      if (this.fragment) {
        // document('#' + this.fragment).scrollIntoView();
        document.getElementById(this.fragment).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    } catch (e) {}
  }

  getFundingGraphData() {
    if (this.funding_list.length > 0) {
      this.funding_list.forEach((data: any) => {
        if (data?.type === 'cumulative') {
          this.haveCumulativeFunding = true;
          this.haveCumulativeFundingYear = data.ay;
        }
        if (
          data.funding_amount != null &&
          data.funding_amount != 0 &&
          data.funding_amount != -1
        ) {
          let foundUpdate = false;
          let result = {
            name: data.ay,
            value: data.funding_amount != null ? data.funding_amount : 0,
          };
          this.fundingChartData.forEach((element) => {
            if (element['name'] == data.ay) {
              element.value = element.value + data.funding_amount;

              this.fundingYearlyData[data.ay].push({
                name: data.investor_name,
                value: data.funding_amount != null ? data.funding_amount : 0,
              });
              foundUpdate = true;
            }
          });
          if (!foundUpdate) {
            this.fundingChartData.push(result);
            if(data.ay == "2017-18"){
              this.years.push('Till '+data.ay);
            }else{
              this.years.push(data.ay);
            }
            // this.years.push(data.ay);
            this.fundingYearlyData[data.ay] = [];
            this.fundingYearlyData[data.ay].push({
              name: data.investor_name,
              value: data.funding_amount != null ? data.funding_amount : 0,
            });
          }
        }
      });
      if(this.years.length > 0){
        if(this.years[0].includes('Till')){
          let yr = this.years[0].substring(5)
          this.tempYear = yr
          this.assesmentYear.patchValue({ ay: 'Till '+this.tempYear });
        }else{
          this.tempYear = this.years[0];
          this.assesmentYear.patchValue({ ay: this.tempYear });
        }
      }
      if (this.fundingChartData.length > 0) {
        this.getFunding(this.fundingChartData[0].name);
      }
    }
  }

  totalFundingPerYear: any;
  changeYear(e) {
    if(e.target.value.includes('Till')){
      let yr = e.target.value.substring(5)
      this.tempYear = yr
    }else{
      this.tempYear = e.target.value;
    }
    this.getFunding(this.tempYear);
  }
  getFunding(year) {
    this.totalFundingPerYear = this.fundingChartData
      .filter((item) => item.name === year)
      .map((item) => item.value);
  }

  getTotal(list, field) {
    return list.reduce(function (a, b) {
      return a + b[field];
    }, 0);
  }

  valueFormatting(value) {
    const filterPipe = new PricePipe();
    return filterPipe.transform(value, null,true);
  }

  addToCart(sku) {
    if (
      this.onSession == undefined ||
      this.onSession == '' ||
      this.onSession == null
    ) {
      this.route.navigate(['/user/login']);
    } else {
    let currentOption;
    currentOption = {
      sku: sku,
    };
    this.tansactionService.addProductToCart(currentOption).then(
      (data: any) => {
        if (this.plan === 'plan_premium' || this.plan === 'plan_advance') {
          this.toastService.addSingle(
            'success',
            'Email Sent',
            'Please check your email.'
          );
        } else {
          this.toastService.addSingle(
            'success',
            'Item added to cart',
            'Make payment to complete this transaction.'
          );
        }
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
    }
  }

  getProductShortName(name) {
    return name.replace(' - ' + name + '.pdf', '');
}

  navigateToIndustryReport(name,sku){
    let isReport = false;
    this.route.navigate([`/company/${this.all_data.name}/product/${this.getProductShortName(name)}/${sku}/${isReport}`]);
  }
}
